document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('keizo-enhanced');

  // Keep the existing sticky header stable. Hiding it on scroll caused awkward gaps
  // around the announcement bar and made the drawer/header interaction feel broken.
  /* KEIZO SMART MOBILE HEADER */
(function initKeizoMobileScrollHeader() {
  var lastY = window.scrollY || window.pageYOffset || 0;
  var threshold = 7;
  var rafPending = false;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function hasOpenDrawer() {
    return !!document.querySelector(
      '#nav-drawer.is-open, #cart-drawer.is-open, .drawer.is-open, dialog[open]'
    );
  }

  function updateHeader() {
    if (!isMobile()) {
      document.body.classList.remove('keizo-scroll-down');
      return;
    }

    var y = window.scrollY || window.pageYOffset || 0;

    if (hasOpenDrawer()) {
      document.body.classList.remove('keizo-scroll-down');
      lastY = y;
      return;
    }

    document.body.classList.toggle('has-scrolled', y > 60);

    if (y < 80) {
      document.body.classList.remove('keizo-scroll-down');
    } else if (y > lastY + threshold) {
      document.body.classList.add('keizo-scroll-down');
    } else if (y < lastY - threshold) {
      document.body.classList.remove('keizo-scroll-down');
    }

    lastY = y;
  }

  function scheduleUpdate() {
    if (rafPending) return;

    rafPending = true;

    window.requestAnimationFrame(function () {
      rafPending = false;
      updateHeader();
    });
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', updateHeader);

  document.addEventListener('click', function () {
    window.setTimeout(updateHeader, 100);
  });

  updateHeader();
})();

  // Bundle selector: keep the real Shopify quantity and displayed tier prices in sync.
  document.querySelectorAll('[data-keizo-bundle-picker]').forEach(function (picker) {
    var form = picker.closest('form[data-product-form]');
    if (!form) return;

    var quantityField = form.querySelector('input[name="quantity"], input[data-quantity-field]');
    if (!quantityField) {
      quantityField = document.createElement('input');
      quantityField.type = 'hidden';
      quantityField.name = 'quantity';
      quantityField.value = '1';
      form.appendChild(quantityField);
    }

    var variantData = [];
    try { variantData = JSON.parse(picker.getAttribute('data-product-variants') || '[]'); } catch (error) { variantData = []; }
    var discountTwo = parseInt(picker.getAttribute('data-discount-two') || '4000', 10);
    var discountThree = parseInt(picker.getAttribute('data-discount-three') || '13500', 10);
    var currency = picker.getAttribute('data-currency') || 'INR';
    var formatter;
    try { formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (error) { formatter = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function money(cents) { return formatter.format(Math.max(0, Number(cents || 0)) / 100); }

    function updateBundlePrices() {
      var idField = form.querySelector('input[name="id"], select[name="id"]');
      var selectedId = idField ? String(idField.value) : '';
      var variant = variantData.find(function (item) { return String(item.id) === selectedId; });
      if (!variant) return;
      var unit = Number(variant.price || 0);
      var compare = Number(variant.compare_at_price || 0);
      if (!compare || compare < unit) compare = unit;
      picker.setAttribute('data-unit-price', String(unit));
      picker.setAttribute('data-unit-compare', String(compare));
      var values = {
        '1': { total: unit, compare: compare },
        '2': { total: Math.max(0, unit * 2 - discountTwo), compare: compare * 2 },
        '3': { total: Math.max(0, unit * 3 - discountThree), compare: compare * 3 }
      };
      Object.keys(values).forEach(function (quantity) {
        var option = picker.querySelector('[data-keizo-bundle-quantity="' + quantity + '"]');
        if (!option) return;
        var priceStrong = option.querySelector('[data-keizo-bundle-price]');
        var compareNode = option.querySelector('[data-keizo-bundle-compare]');
        if (priceStrong) priceStrong.textContent = money(values[quantity].total);
        if (compareNode) {
          if (values[quantity].compare > values[quantity].total) {
            compareNode.textContent = money(values[quantity].compare);
            compareNode.hidden = false;
          } else {
            compareNode.hidden = true;
          }
        }
      });
    }

    picker.querySelectorAll('[data-keizo-bundle-quantity]').forEach(function (option) {
      option.addEventListener('click', function () {
        var quantity = parseInt(option.getAttribute('data-keizo-bundle-quantity'), 10);
        if (!Number.isFinite(quantity) || quantity < 1) return;
        form.querySelectorAll('input[name="quantity"], input[data-quantity-field]').forEach(function (field) {
          field.value = String(quantity);
          field.setAttribute('value', String(quantity));
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });
        picker.querySelectorAll('[data-keizo-bundle-quantity]').forEach(function (peer) {
          var active = peer === option;
          peer.classList.toggle('is-selected', active);
          peer.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    form.addEventListener('change', function () { window.setTimeout(updateBundlePrices, 80); });
    document.addEventListener('variant:changed', updateBundlePrices);
    updateBundlePrices();
  });

  // Ensure a visible Buy Now action even if the third-party GoKwik SDK fails to initialise.
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var gokwikWrap = form.querySelector('[data-keizo-gokwik-buy-now-wrap]');
    var gokwikButton = form.querySelector('#gokwik-buy-now');
    var fallbackWrap = form.querySelector('[data-keizo-buy-now-fallback]');
    var fallbackButton = form.querySelector('[data-keizo-buy-now-button]');
    if (!fallbackWrap || !fallbackButton) return;
    if (form.closest('.variant--soldout')) return;

    function showFallback() {
      if (gokwikButton && !gokwikButton.disabled) {
        showGoKwik();
        return;
      }
      if (gokwikWrap) gokwikWrap.hidden = true;
      fallbackWrap.hidden = false;
    }
    function showGoKwik() {
      if (gokwikWrap) gokwikWrap.hidden = false;
      fallbackWrap.hidden = true;
    }

    if (!gokwikButton) {
      showFallback();
    } else {
      // Show a working CTA immediately while GoKwik is still disabled/loading.
      if (gokwikButton.disabled) showFallback();
      var readinessAttempts = 0;
      var readinessPoll = window.setInterval(function () {
        readinessAttempts += 1;
        if (gokwikButton && !gokwikButton.disabled) {
          showGoKwik();
          window.clearInterval(readinessPoll);
        } else if (readinessAttempts >= 20) {
          window.clearInterval(readinessPoll);
        }
      }, 600);
      window.addEventListener('gokwikLoaded', function () {
        window.setTimeout(function () {
          if (!gokwikButton.disabled) {
            showGoKwik();
            window.clearInterval(readinessPoll);
          }
        }, 120);
      });
    }

    fallbackButton.addEventListener('click', function () {
      var variantField = form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[name="id"][type="hidden"]') || form.querySelector('[name="id"]');
      var quantityField = form.querySelector('[name="quantity"], [data-quantity-field]');
      var quantity = Math.max(1, parseInt(quantityField && quantityField.value || '1', 10) || 1);
      var variantId = variantField && variantField.value;
      var error = fallbackWrap.querySelector('[data-keizo-buy-now-error]');
      var addUrl = fallbackButton.getAttribute('data-cart-add-url') || '/cart/add.js';
      var checkoutUrl = fallbackButton.getAttribute('data-checkout-url') || '/checkout';
      if (!variantId) {
        if (error) { error.textContent = 'Please choose an available product option first.'; error.hidden = false; }
        return;
      }
      if (error) { error.textContent = ''; error.hidden = true; }
      fallbackButton.disabled = true;
      fallbackButton.classList.add('is-loading');
      fallbackButton.textContent = 'Preparing checkout…';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: quantity })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || data.message || 'Unable to add this item.'); });
        return response.json();
      }).then(function () {
        window.location.assign(checkoutUrl);
      }).catch(function (err) {
        fallbackButton.disabled = false;
        fallbackButton.classList.remove('is-loading');
        fallbackButton.textContent = 'Buy Now';
        if (error) { error.textContent = err && err.message ? err.message : 'Something went wrong. Please try Add to Cart.'; error.hidden = false; }
      });
    });
  });

  // Discount codes use Shopify's discount endpoint, then return the shopper to the cart.
  document.querySelectorAll('[data-keizo-discount-entry]').forEach(function (entry) {
    var input = entry.querySelector('[data-keizo-discount-input]');
    var applyButton = entry.querySelector('[data-keizo-apply-discount]');
    var fillButton = entry.querySelector('[data-keizo-fill-discount]');
    var message = entry.querySelector('[data-keizo-discount-message]');
    if (!input || !applyButton) return;
    function applyDiscount() {
      var code = input.value.trim().replace(/\s+/g, '');
      if (!code) {
        if (message) message.textContent = 'Enter a discount code to apply it.';
        input.focus();
        return;
      }
      var prefix = entry.getAttribute('data-discount-prefix') || '/discount/';
      var redirectPath = entry.getAttribute('data-redirect-path') || '/cart';
      applyButton.disabled = true;
      applyButton.textContent = 'Applying…';
      window.location.assign(prefix + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath));
    }
    applyButton.addEventListener('click', applyDiscount);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') { event.preventDefault(); applyDiscount(); }
    });
    if (fillButton) fillButton.addEventListener('click', function () { input.value = 'WELCOME10'; input.focus(); });
  });



  // KEIZO V14: keep the custom "Make it a set" picker and hide only the
  // duplicate Pumper/app widget whose visible heading is "Quantity Bundle".
  // The app embed remains enabled for its existing quantity-break/discount logic.
  (function hideDuplicateQuantityBundleWidget() {
    var hiddenAttribute = 'data-keizo-hidden-duplicate-quantity-bundle';
    var protectedSelectors = [
      '.keizo-bundle-picker',
      '.product__submit__buttons',
      '[data-keizo-gokwik-buy-now-wrap]',
      '[data-keizo-buy-now-fallback]',
      '.keizo-product-assurance'
    ];
    var widgetClassPattern = /(pumper|quantity[\s_-]*break|quantity[\s_-]*bundle|bundle[\s_-]*widget|volume[\s_-]*discount|tier[\s_-]*discount|shopify-app-block|app-block)/i;
    var majorBoundarySelector = 'form[data-product-form], .product__form__wrapper, .product-single__details, .product-single';

    function classText(el) {
      if (!el) return '';
      var classes = typeof el.className === 'string' ? el.className : (el.getAttribute('class') || '');
      return classes + ' ' + (el.id || '');
    }

    function matchesProtected(el) {
      return protectedSelectors.some(function (selector) {
        try { return el.matches(selector); } catch (error) { return false; }
      });
    }

    function containsProtected(el) {
      return protectedSelectors.some(function (selector) {
        try { return !!el.querySelector(selector); } catch (error) { return false; }
      });
    }

    function controlCount(el) {
      return el.querySelectorAll(
        'button, input[type="radio"], [role="radio"], [role="button"], ' +
        'label[class*="option"], [class*="quantity-break__option"], ' +
        '[class*="quantity-break-option"], [data-quantity-break], [data-quantity-option]'
      ).length;
    }

    function isUnsafeCandidate(el) {
      if (!el || el === document.body || el === document.documentElement) return true;
      if (matchesProtected(el) || containsProtected(el)) return true;
      if (el.matches('form, .product-single, .product-single__details, .product__form__wrapper')) return true;
      return false;
    }

    function markHidden(el) {
      if (!el || isUnsafeCandidate(el)) return false;
      el.setAttribute(hiddenAttribute, 'true');
      el.setAttribute('aria-hidden', 'true');
      return true;
    }

    function hideWidgetForHeading(heading) {
      if (!heading || heading.closest('.keizo-bundle-picker')) return;
      if (heading.closest('[' + hiddenAttribute + '="true"]')) return;

      var node = heading.parentElement;
      var depth = 0;
      var genericCandidate = null;

      // First pass: prefer the nearest explicitly named app/widget wrapper.
      while (node && node !== document.body && depth < 14) {
        var classes = classText(node);
        var controls = controlCount(node);
        if (controls >= 2 && widgetClassPattern.test(classes) && !isUnsafeCandidate(node)) {
          if (markHidden(node)) return;
        }
        if (node.matches(majorBoundarySelector)) break;
        node = node.parentElement;
        depth += 1;
      }

      // Second pass: app embeds sometimes have generated class names. Find the
      // smallest safe ancestor holding the heading and at least two bundle options.
      node = heading.parentElement;
      depth = 0;
      while (node && node !== document.body && depth < 10) {
        if (node.matches(majorBoundarySelector)) break;
        if (!isUnsafeCandidate(node) && controlCount(node) >= 2) {
          genericCandidate = node;
          break;
        }
        node = node.parentElement;
        depth += 1;
      }
      if (genericCandidate && markHidden(genericCandidate)) return;

      // Final fallback: only hide the dedicated Shopify app block, never the
      // product form or a parent containing our custom picker/purchase controls.
      var appBlock = heading.closest('.shopify-app-block, [id*="shopify-block"], [class*="pumper"], [class*="quantity-break"], [class*="bundle-widget"]');
      if (appBlock && controlCount(appBlock) >= 2) markHidden(appBlock);
    }

    function scanForDuplicate(root) {
      if (!root || !root.querySelectorAll) return;
      var selector = 'h1, h2, h3, h4, h5, h6, [class*="title"], [class*="heading"], legend, strong';
      var headings = root.querySelectorAll(selector);
      headings.forEach(function (heading) {
        var text = (heading.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (text === 'quantity bundle') hideWidgetForHeading(heading);
      });
    }

    function runScan() { scanForDuplicate(document); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runScan, { once: true });
    } else {
      runScan();
    }
    if (window.MutationObserver && document.body) {
      var scanQueued = false;
      var observer = new MutationObserver(function () {
        if (scanQueued) return;
        scanQueued = true;
        window.setTimeout(function () {
          scanQueued = false;
          runScan();
        }, 100);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // Make Shopify validation results in the bespoke contact form easy to find.
  var contactForm = document.getElementById('KeizoContactForm');
  if (contactForm && (contactForm.querySelector('.keizo-form-error') || contactForm.querySelector('.keizo-form-notice'))) {
    contactForm.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
});
